<template>
  <b-skeleton-img v-if="fetching" :height="height" :width="width" no-aspect></b-skeleton-img>

  <div
    v-else
    :style="thumbnailStyle"
    class="img-fluid rounded thumbnail d-flex justify-content-center align-items-center"
  >
    <div v-if="text" :style="textStyle">{{ text }}</div>
  </div>
</template>

<script>
import Upload from '@/models/Upload';

export default {
  props: {
    file: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: '160px'
    },
    height: {
      type: String,
      default: '160px'
    },
    backgroundSize: {
      type: String,
      default: 'cover'
    },
    backgroundPosition: {
      type: String,
      default: 'top center'
    },
    backgroundVariant: {
      type: String,
      default: 'medium'
    },
    text: {
      type: String,
      default: ''
    },
    textFontSize: {
      type: String,
      default: '16px'
    },
    textVariant: {
      type: String,
      default: 'dark'
    },
    textFontWeight: {
      type: String,
      default: 'bold'
    },
    static: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      src: '',
      fetching: false
    };
  },

  computed: {
    thumbnailStyle() {
      const style = {
        width: `${this.width}`,
        height: `${this.height}`,
        backgroundSize: this.backgroundSize,
        backgroundPosition: this.backgroundPosition,
        backgroundColor: `var(--${this.backgroundVariant})`,
        backgroundRepeat: 'no-repeat'
      };

      if (this.static) {
        if (this.text) {
          // this.$set(style, 'backgroundImage', `url(${this.src})`);
        }
      } else {
        if (this.src) {
          this.$set(style, 'backgroundImage', `url(${this.src})`);
        }
      }

      return style;
    },

    textStyle() {
      const style = {
        fontSize: this.textFontSize,
        color: `var(--${this.textVariant})`,
        fontWeight: this.textFontWeight
      };

      return style;
    }
  },

  async mounted() {
    if (this.file) {
      this.fetching = true;

      const { response } = await Upload.api().fetchPresignedUrl(this.file.id);

      const { url } = response.data;

      if (url) {
        this.src = url;
      }

      this.fetching = false;
    }
  }
};
</script>
